import { useState } from 'react';
import axios from 'axios';
import { API_STATUS } from '../utils/constants';
import { getApiHeaders } from '../utils/header-util';
import { toastWarn } from '../utils/toasts';

export function useCreateApi() {
   const [createApiResponseData, setCreateApiResponseData] = useState(null);
   const [createApiStatus, setCreateApiStatus] = useState(
      API_STATUS.IN_PROGRESS
   );

   const create = async (url) => {
      try {
         const response = await axios.get(url, {
            headers: getApiHeaders(),
         });

         if (response.status !== 200) {
            toastWarn(response.data.message);
            setCreateApiResponseData({});
            setCreateApiStatus(API_STATUS.FAILED);
            return null;
         } else {
            setCreateApiResponseData(response?.data);
            setCreateApiStatus(API_STATUS.SUCCESS);
            return response?.data;
         }
      } catch (error) {
         console.warn('Error in creating', error);
         setCreateApiResponseData({});
         setCreateApiStatus(API_STATUS.FAILED);
         toastWarn(error.message);
         return null;
      }
   };

   return { createApiResponseData, createApiStatus, create };
}
